import { AxiosResponse } from "axios";

import { IAddDeviceRequest, IDevice, IDeviceType } from "../@types/Devices";
import { IPaginatedResponse } from "../@types/PaginatedResponse";
import { api } from "./api";

export const devicesService = {
  async getAllDevices(patientId: number): Promise<AxiosResponse<IDevice[]>> {
    const url = `/Portal/Devices/${patientId}`;
    const devices = await api.get(url);

    if (devices !== undefined) {
      return devices;
    }

    throw Error;
  },

  async getDevicesPaginated(
    patientId: number,
    page?: number,
    pageSize?: number
  ): Promise<AxiosResponse<IPaginatedResponse<IDevice[]>>> {
    const url = `/Portal/Devices/${patientId}`;

    const params: Record<string, number> = {};

    if (page !== undefined) {
      params.page = page;
    }
    if (pageSize !== undefined) {
      params.pageSize = pageSize;
    }

    return api.get<IPaginatedResponse<IDevice[]>>(url, { params });
  },

  async getDeviceTypes(): Promise<AxiosResponse<IDeviceType[]>> {
    const url = `/Portal/Devices/types`;
    const devices = await api.get(url);

    if (devices !== undefined) {
      return devices;
    }

    throw Error;
  },

  async addDevice(request: IAddDeviceRequest): Promise<AxiosResponse> {
    const url = `/Portal/Devices`;
    const devices = await api.post(url, request);

    if (devices !== undefined) {
      return devices;
    }

    throw Error;
  },

  async deleteDevice(identifier: string): Promise<AxiosResponse> {
    const url = `/Portal/Devices/${identifier}`;

    const devices = await api.delete(url);

    if (devices !== undefined) {
      return devices;
    }

    throw Error;
  },
};
